<template>
    <div ref="scrollcontent" v-infinite-scroll="loadMore" infinite-scroll-disabled="loadBusy" infinite-scroll-immediate="false">
        <slot name="header"></slot>
        <div v-show="drawer && searchableColumn && searchableColumn.length > 0" class="exact_search">
            <item-group ref="exact_search" :columns="searchableColumn" @change="ChangeCondition" label-position="left"></item-group>
        </div>
        <el-row>
            <el-col :span="filterSpan[0] || 18">
                <el-row type="flex" justify="start" align="middle" class="align-left">
                    <slot name="filter"></slot>
                    <el-col :span="filterSpan[1] || 6" v-if="enableFilter.enabled" class="padding-right10">
                        <item-input type="search" :placeholder="searchPlaceholder" v-model="searchValue" @input="_search()" class="width-p100"></item-input>
                    </el-col>
                    <el-col :xl="filterSpan[2] || 4" :md="filterSpan[2] || 6" v-if="rowChangesMonitor && rowChanges.length > 0" class="ellipsis">
                        <el-button type="primary" size="mini" @click="SaveChanges"><i class="el-icon-loading" v-if="!finished"></i>保存({{ rowChanges.length }})</el-button>
                        <el-button type="button" plain size="mini" @click="clearChanges">撤销</el-button>
                    </el-col>
                    <el-col :md="filterSpan[3] || 3" :xl="filterSpan[3] || 2" v-if="showChangeOrderButton" class="ellipsis">
                        <el-link type="primary" size="mini" @click="showDisplayOrder = !showDisplayOrder">{{ showDisplayOrder ? '关闭排序' : '修改排序' }}</el-link>
                    </el-col>
                    <el-col :md="filterSpan[4] || 4" :lg="filterSpan[4] || 3" :xl="filterSpan[4] || 2" v-if="searchableColumn && searchableColumn.length > 0">
                        <el-link type="primary" size="mini" @click="AccurateQuery()"><span>精确查询</span><i :class="drawer ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i></el-link>
                    </el-col>
                    <el-col :span="filterSpan[5] || 1" v-if="searchableColumn && searchableColumn.length > 0" class="ellipsis">
                        <el-link type="info" size="mini" @click="Reset()" title="重置"><span class="hidden-md-and-down">重置</span> <i class="el-icon-refresh-right"></i></el-link>
                    </el-col>
                    <slot name="filter-select"></slot>
                </el-row>
            </el-col>
            <el-col :span="(filterSpan[0] && 24 - filterSpan[0]) || 6" class="align-right line-height40">
                <slot name="filter-after"></slot>
                <el-button
                    v-if="rowChanges.length < 1 && enableAddButton.enabled"
                    v-has-permission="enableAddButton.permission"
                    :type="enableAddButton.type"
                    size="mini"
                    @click="ExtraButtonClick({ emit: enableAddButton.emit })"
                    >{{ enableAddButton.label }}</el-button
                >
                <el-popover placement="bottom" :open-delay="600">
                    <el-button size="mini" plain v-show="columnConfig" slot="reference">
                        <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                        <span class="hidden-md-and-down">&nbsp;列配置</span>
                    </el-button>
                    <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 250px; width: max-content">
                        <div class="config-column">
                            <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                        </div>
                    </el-scrollbar>

                    <el-divider></el-divider>
                    <div style="text-align: right">
                        <el-link type="primary" size="mini" class="margin-right10" @click="SaveUserColumns">保存</el-link>
                    </div>
                </el-popover>
            </el-col>
        </el-row>
        <slot name="table-title"></slot>
        <div v-if="isDisplayCount" style="text-align: left">
            <slot>共计{{ _datalist.length }}例</slot>
        </div>
        <ListView
            :showSequence="showSequence"
            ref="cus-listView"
            :selection="selection"
            :datalist="_datalist"
            :columns="userListColumn"
            :tableHeight="tableHeight"
            :tableStyle="tableStyle"
            :sort="sort"
            :defaultSort="defaultSort"
            :buttons="enabledButtons"
            :rowDropDisabled="rowDropDisabled"
            @changeColWidth="changeColWidth"
            @extrabutton-click="ExtraButtonClick"
            @change="RowChange"
            :stripe="stripe"
            @exchange-row="exchangeRow"
            :spanMethod="spanMethod"
            @scrollToEnd="loadMore"
        >
            <!-- <template :slot="status_column" slot-scope="scope" v-if="scope.column.readonly==false">
        {{scope.column.label}}<i class="el-icon-sort" style="transform:rotate(-90deg);" @click="changeStatus()"></i>
      </template> -->
            <template slot-scope="{ index, row, column }" slot="column">
                <slot :index="index" :row="row" :column="column" :name="column.prop"></slot>
            </template>
        </ListView>
        <!-- <div v-if="loadBusy" style="height:20px;color:#909399;">
      <span v-if="noMore" style="padding:20px">&nbsp;</span>
      <span v-else><i class="el-icon-loading"></i>正在加载前{{page}}页，前{{virtualPage*10}}条...</span>
    </div> -->

        <!--编辑区域-->
        <FormDialog
            :title="editDialog.title"
            :data="editDialog.data"
            :width="dialogWidth"
            :visible.sync="editDialog.dialogFormVisible"
            :label-width="maxLabelWidth"
            :columns="editableColumns"
            :showconfirm="showconfirm"
            @confirm="UpdateData"
            :buttons="enabledEditButtons"
            @extrabutton-click="ExtraButtonClick"
        ></FormDialog>
        <!--新建区域-->
        <FormDialog
            ref="create-dialog"
            :title="createDialog.title"
            :data="createDialog.data"
            :width="dialogWidth"
            :visible.sync="createDialog.dialogFormVisible"
            :label-width="maxLabelWidth"
            :columns="creatableColumns"
            @confirm="SaveData"
            :buttons="enabledEditButtons"
            @extrabutton-click="ExtraButtonClick"
        ></FormDialog>
    </div>
</template>

<script>
import definition from './Definition'

import Sortable from 'sortablejs'
/*
  * init:{
  *   url:"",
  *   filter:{
            enabled: true,
            handle: (rowdata, searchvalue) => {
              return new RegExp(searchvalue).test(rowdata.username)
            },
          },
  *   columns:[{
  *     type:"string",
  *     prop:"id",
  *     label:"ID",
  *     width:"180",
  *     isListable:false,
  *     isExpand:false,
  *     isEditable:false,
  *     isCreatable:false,
  *     isKey:false
  *   }],
  *   buttons: [{
  *         enabled:true,
            name: "修改密码",
            type: "button",
            emit: "LoadingAlterPasswordView"
          }]
  * }
  *
  * */
export default {
    name: `crud-facecade`,
    inject: [`reload`],
    props: {
        url: { type: String | Object },
        columns: Array,
        editColums: Array,
        customFixedColumns: Array,
        buttons: Array,
        editButtons: Array,
        addButton: Object,
        deleteButton: Object,
        updateButton: Object,
        detailButton: Object,
        selection: { type: Boolean, default: false },
        treeProps: {
            type: Object,
            default: () => ({
                enabled: false,
                parent: `parent_id`
            })
        },
        infiniteLoad: false, // 开启远程搜索加载
        status_column: { type: String, default: `is_deleted` },
        dialogWidth: { type: String },
        columnConfig: false,
        showSequence: true,
        fuzzySearch: { type: Boolean, default: true },
        searchLocal: { type: Boolean, default: true },
        rowDropDisabled: { type: Boolean, default: true },
        rowChangesMonitor: { type: Boolean, default: true },
        tableHeight: { type: Number },
        tableStyle: { type: String },
        new_row_tag: { type: String, default: undefined },
        isDisplayCount: { type: Boolean, default: false },
        filterSpan: { type: Array, default: () => [18] },
        sort: { type: Boolean, default: false },
        searchPlaceholder: { type: String, default: `关键字搜索` },
        spanMethod: { type: Function },
        stripe: { type: Boolean, default: true },
        defaultSort: { type: Object },
        disableOrderDefaultSort: { type: Boolean, default: false },
        afterUpdate: { type: Function }
    },
    components: {
        ListView: () => import(`./ListView.vue`),
        FormDialog: () => import(`./FormDialog.vue`)
    },
    data() {
        return {
            showDisplayOrder: false,
            dataList: [], // 所有数据
            searchValue: ``, // 搜索框输入值
            editDialog: {
                dialogFormVisible: false, // 修改编辑区域是否显示
                data: {}, // 正在编辑的数据
                title: `修改`
            },
            createDialog: {
                dialogFormVisible: false, // 修改编辑区域是否显示
                data: {}, // 正在编辑的数据
                title: `新建`
            },
            showconfirm: true,
            searchColumnData: {},
            rowChanges: [],
            finished: true,
            drawer: false,
            page: 1,
            virtualPage: 5,
            loadBusy: false,
            noMore: false,
            scrolltop: 0,
            user_config_columns: [],
            user_config_columns2: [],
            minValue: `-2147483648`,
            configColumns: []
        }
    },
    mounted() {
        if (this.columnConfig) {
            this.$nextTick(function() {
                this.configColumnDrop()
                this.LoadUserColumns()
            })
        }
    },
    beforeMount() {
        // this.configColumns = []
        this._search = _.debounce(this.beforeSearch, 300)
        this.ReloadListData()
    },
    computed: {
        _url() {
            let r = {
                baseURL: undefined,
                get: undefined,
                put: undefined,
                post: undefined,
                delete: undefined,
                putMany: undefined,
                getOne: undefined
            }
            // console.log(typeof this.url === 'string')
            if (typeof this.url === `string`) {
                r.baseURL = this.url
            } else {
                Object.assign(r, this.url)
            }

            if (!r.get) {
                r.get = r.baseURL + `/Get`
            }
            if (!r.put) {
                r.put = r.baseURL + `/Put`
            }
            if (!r.post) {
                r.post = r.baseURL + `/Post`
            }
            if (!r.delete) {
                r.delete = r.baseURL + `/Delete`
            }
            if (!r.putMany) {
                r.putMany = r.baseURL + `/PutMany`
            }

            return r
        },
        _datalist() {
            let r = _.take(this.dataList, this.virtualPage * 10)
            // this.loadBusy = false
            // let r = this.dataList
            if (this.dataList_bak) {
                if (this.dataList_bak.length <= this.virtualPage * 10 && this.dataList.length > 0) {
                    this.noMore = true
                    // this.loadBusy=true
                }
            }
            return r
        },
        searchableColumn() {
            return _.filter(this.columnList, function(i) {
                return i.searchable
            }).map(c => {
                let r = { ...c }
                if (r.type == `rbool` || r.type == `bool`) {
                    r.type = `select`
                }
                r.default = ``
                return r
            })
        },
        maxLabelWidth() {
            let c = _.maxBy(this.columns, function(o) {
                return (o.label && o.label.length) || 0
            })
            return c && c.label && c.label.length ? (c.label && (c.label.length + 1) * 20) + `px` : `20px`
        },
        columnList() {
            if (this.columns.length == 0) {
                console.log(`crudfacecade  props.columns length is 0! `)
            }
            let cls = []
            let that = this
            cls = _.map(this.columns, c => {
                let ct = _.cloneDeep(c)
                if (ct.isDisplayOrder && !that.showDisplayOrder) {
                    ct.isListable = false
                }
                return ct
            })
            if (_.findIndex(cls, { prop: `abbr` }) === -1) {
                // 默认带上简拼列，用于搜索
                cls.push({
                    type: `string`,
                    prop: `abbr`,
                    label: `简拼`
                })
            }

            // mustColumns.forEach((row,index,list)=>{
            //   let  mc=_.find(cls,{prop:row.prop})
            //   if(mc){
            //     Object.assign(mc,row)
            //   }else{
            //     cls.push(_.cloneDeep(row))
            //   }
            // })
            return cls
        },
        showChangeOrderButton() {
            return _.findIndex(this.columns, { isDisplayOrder: true }) > -1
        },
        listColumn() {
            let r = _.filter(this.columnList, { isListable: true })
            return r
        },
        userListColumn() {
            let that = this
            let fixedColumns = this.customFixedColumns && this.customFixedColumns.length > 0 ? this.customFixedColumns : []
            let cloneColumnList = this.columnList.map(d => {
                let ct = _.cloneDeep(d)
                if (fixedColumns.findIndex(i => i == ct.label) > -1 && ct.isListable && !ct.fixed) {
                    ct.fixed = `left`
                }
                return ct
            })
            if (this.columnConfig && this.configColumns.length == 0) {
                return cloneColumnList
            } else if (this.columnConfig && this.user_config_columns.length == 0) {
                // added by xiaorui,默认如果用户没有配置任何列 则 1.列配置勾选上当前页面所有列 2.展示当前列表上所有列
                that.user_config_columns = that.configColumns.map(c => c.value)
                return cloneColumnList
            } else if (!this.columnConfig) {
                return cloneColumnList
            }

            // 用户保存了配置列，则获取所有enabled的配置列
            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            // debugger
            allcolumn.map(d => {
                // debugger
                let f = that.user_config_columns2.find(s => s.col_name == d.prop)
                if (f && f.col_width > 0) {
                    d.width = f.col_width
                }
            })

            // 用户配置列排序
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })

            r.map((d, index) => {
                // 如果参数设置中把当前列设置成了固定列，给当前列加上 fixed=left属性
                if (fixedColumns.findIndex(i => i == d.label) > -1 && d.isListable && !d.fixed) {
                    // 用户私有化后如果把当前列已经排好顺序了且排在当前列前面的列存在非固定列，固定列不需要设置fixed=left属性，因为设置后会改变列排序
                    let lefts = _.take(r, index)
                    let leftListables = _.filter(lefts, c => c.isListable && c.isListable == true)
                    let unfixed = leftListables.find(i => !i.fixed)
                    if (!unfixed) {
                        d.fixed = `left`
                    }
                }
                return d
            })
            return r
        },
        customList() {
            return _.filter(this.columnList, { type: `custom` })
        },
        queryableColumn() {
            let that = this
            let r = _.filter(this.columnList, function(i) {
                // 默认带上简拼  abbr
                return ((i.searchable || i.isListable || i.prop == `abbr` || i.queryable) && i.type != `buttongroup`) || i.prop == `patient_abbr`
            }).map(c => {
                let ct = _.cloneDeep(c)
                if (ct.options && _.isString(ct.options)) {
                    ct.options = that.$store.getters[ct.options]
                } else if (ct.options && _.isFunction(ct.options)) {
                    let ops = ct.options(that, { area: `crudfacecade`, column: ct, row: {} })
                    if (_.isArray(ops)) {
                        ct.options = ops
                    } else if (_.isString(ops)) {
                        ct.options = that.$store.getters[ops]
                    }
                }
                return ct
            })
            return r
        },
        enableFilter() {
            let that = this
            return {
                enabled: this.fuzzySearch,
                handle: (rowdata, searchvalue, sc) => {
                    searchvalue = searchvalue && searchvalue.replace(`\\`, ``)
                    let reg = new RegExp(searchvalue, `i`)
                    // searchColumnData 采用与逻辑查询
                    let qc = that.queryableColumn
                    if (!_.isEmpty(sc)) {
                        let result = _.every(qc, function(o) {
                            let v = rowdata[o.prop]
                            if (sc[o.prop] !== undefined && sc[o.prop] !== `` && sc[o.prop] !== `Invalid date`) {
                                if (o.options) {
                                    // 具有option选项使用等于搜索
                                    if (_.isArray(sc[o.prop])) {
                                        if (sc[o.prop].length == 0) return true
                                        return _.some(v, function(rd) {
                                            return _.includes(sc[o.prop], rd)
                                        })
                                    }
                                    return v == sc[o.prop]
                                } else if ((o.type == `datetime` || o.type == `date` || o.type == `time`) && v) {
                                    return new RegExp(sc[o.prop], `i`).test(that.$moment(v).format(`YYYY/MM/DD HH:mm:ss`))
                                } else {
                                    return new RegExp(sc[o.prop], `i`).test(v)
                                }
                            }
                            return true
                        })
                        if (!result) {
                            return false
                        }
                    }

                    if (searchvalue.length == 0) {
                        return true
                    }
                    return _.some(qc, function(o) {
                        // searchkey  采用或逻辑查询,searchkey本身与searchColumnData是与逻辑
                        let v = rowdata[o.prop]
                        if (v && o.type == `remotemultiselect`) {
                            return (
                                _.findIndex(v, d => {
                                    // ACIS-23792 手术排程，过滤查看已排程手术界面，可通过关键字搜索数据(非空未判断，当d为空，d.value异常，修复该bug)
                                    if (d) {
                                        return reg.test(d.value) || reg.test(d.jianpin) || reg.test(d.label)
                                    }
                                }) > -1
                            )
                        } else if (v && (o.type == `remoteselect` || o.type == `remoteselecttable`)) {
                            return reg.test(v.value) || reg.test(v.jianpin) || reg.test(v.label)
                        } else if (o.options && _.isArray(o.options)) {
                            // let tarOpt = _.find(o.options, { value: v })//  找到当前值的option选项
                            let tarOpts = _.filter(o.options, function(op) {
                                return reg.test(op.label) || reg.test(op.jianpin)
                            }).map(op => op.value) //  找到当前值的option选项
                            if (!tarOpts) {
                                return false
                            }
                            return _.includes(tarOpts, v)
                            // return reg.test(tarOpt.label)
                        } else if ((o.type == `datetime` || o.type == `date` || o.type == `time`) && v) {
                            return reg.test(that.$moment(v).format(`YYYY/MM/DD HH:mm:ss`))
                        } else if (o.options && _.isFunction(o.options)) {
                            return false
                        }
                        return reg.test(v)
                    })
                }
            }
        },
        enableAddButton() {
            return Object.assign({}, new definition.TouchButtonDefinition({ label: `创建`, type: `primary`, emit: `LoadingAddView` }), this.addButton)
        },
        enableDeleteButton() {
            return Object.assign({}, new definition.TouchButtonDefinition({ label: `删除`, type: `danger`, enabled: false, emit: `DeleteData` }), this.deleteButton)
        },
        enableUpdateButton() {
            return Object.assign({}, new definition.TouchButtonDefinition({ label: `编辑`, type: `primary`, emit: `LoadingUpdateView` }), this.updateButton)
        },
        enableDetailButton() {
            return Object.assign({}, new definition.TouchButtonDefinition({ label: `详情`, type: `primary`, emit: `LoadingDetailView` }), this.detailButton)
        },
        enabledButtons() {
            let bts = (this.buttons || []).map(b => Object.assign(new definition.TouchButtonDefinition({}), b))
            if (this.enableUpdateButton.enabled) {
                bts.push(this.enableUpdateButton)
            }
            if (this.enableDeleteButton.enabled) {
                bts.push(this.enableDeleteButton)
            }
            return bts
        },
        enabledEditButtons() {
            let bts = (this.editButtons || []).map(b => Object.assign(new definition.TouchButtonDefinition({}), b))
            return bts
        },
        creatableColumns() {
            return this.SelectColumnProperty(_.filter(this.columnList, { isCreatable: true }))
        },
        editableColumns() {
            if (this.editColums) {
                return this.SelectColumnProperty(_.filter(this.editColums, { isEditable: true }))
            } else {
                return this.SelectColumnProperty(_.filter(this.columnList, { isEditable: true }))
            }
        },
        keyColumns() {
            return _.filter(this.columnList, { isKey: true })
        },
        sortableColumns() {
            return _.filter(this.columnList, c => {
                return c.sortable && _.includes([true, `asc`, `desc`], c.sortable)
            }).map(s => {
                return { prop: s.prop, by: s.sortable == `desc` ? `desc` : `asc` }
            })
        },
        tableName() {
            let tableName = _.trim(this._url.baseURL, ` /`) // 替换末尾空格和/
            return (this._url.area && `${tableName.replace(`/`, `_`)}_${this._url.area}`) || tableName.replace(`/`, `_`)
        }
    },
    methods: {
        AppendListData(data) {
            let that = this
            if (!this.searchLocal) {
                that.ListData(data)
            } else {
                let keys = that.keyColumns
                let r
                if (keys.length > 0) {
                    r = _.differenceWith(that.dataList_bak || [], data, function(arrVal, othVal) {
                        return _.every(keys, function(k) {
                            return arrVal[k.prop] === othVal[k.prop]
                        })
                    }) // 去重
                }
                r = data && r.concat(data)
                if (!that.disableOrderDefaultSort) {
                    r = _.orderBy(
                        r,
                        this.sortableColumns.map(c => c.prop),
                        this.sortableColumns.map(c => c.by)
                    ) // 排序
                }
                that.dataList_bak = r
                that.search()
            }
        },
        ListData(data) {
            let that = this
            that.dataList_bak = data
            that.dataList = _.cloneDeep(data)
        },
        ReloadListData(reset) {
            let that = this
            that.page = 1 // 重新从第一页获取
            // that.virtualPage = 5 //重新从第一页获取
            that.noMore = false
            that.dataList_bak = [] // 清空数据仓库
            if (reset) {
                that.rowChanges = []
            }
            that.QueryData(reset).then(data => {
                that.AppendListData(data)
            })
        },
        SelectColumnProperty(columnList) {
            // 编辑与修改列属性
            return columnList.map(function(column, index, array) {
                let r = { type: column.type, prop: column.prop, label: column.label, colspan: column.colspan, showCount: column.showCount, collapseTags: column.collapseTags }
                if (column.options) {
                    r.options = column.options
                }
                if (column.validate && column.validate.length > 0) {
                    r.validate = column.validate
                }
                if (column.change) {
                    r.change = column.change
                }
                if (column.default != undefined) {
                    r.default = column.default
                }
                if (column.meta) {
                    r.meta = column.meta
                }
                if (column.readonly != undefined) {
                    r.readonly = column.readonly
                }
                if (column.placeholder != undefined) {
                    r.placeholder = column.placeholder
                }
                if (column.config != undefined) {
                    r.config = column.config
                }
                if (column.showCount != undefined) {
                    r.showCount = column.showCount
                }
                if (column.collapseTags != undefined) {
                    r.collapseTags = column.collapseTags
                }
                if (column.decimal_places) {
                    r.decimal_places = column.decimal_places
                }
                if (column.field_style) {
                    r.field_style = column.field_style
                }
                return r
            })
        },
        beforeSearch() {
            let that = this
            that.page = 1
            if (this.infiniteLoad) {
                that.QueryData()
                    .then(data => {
                        if (data.length > 0) {
                            that.AppendListData(data)
                        } else {
                            that.search()
                        }
                    })
                    .catch(e => {
                        that.search()
                    })
            } else if (!this.searchLocal) {
                that.QueryData()
                    .then(data => {
                        that.AppendListData(data)
                    })
                    .catch(e => {
                        that.search()
                    })
            } else {
                that.search()
            }
        },
        search() {
            let that = this
            let sc = { ...that.searchColumnData }
            let r = _.filter(this.dataList_bak, function(u) {
                return u && that.enableFilter.handle(u, that.searchValue, sc)
            })
            _.each(r, d => {
                if (that.searchValue && that.searchValue != `` && d.searchName && _.includes(d.searchName, that.searchValue)) {
                    if (!_.includes(d.class_name, ` subitemRed`)) {
                        d.class_name += ` subitemRed`
                    }
                } else {
                    if (d.class_name && _.includes(d.class_name, `subitemRed`)) {
                        d.class_name = d.class_name.replace(`subitemRed`, ``)
                    }
                }
            })
            this.dataList = _.cloneDeep(r)
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        LoadingAddView(row) {
            let that = this
            this.showconfirm = true
            let d = {}
            for (var c in this.creatableColumns) {
                if (this.creatableColumns[c].default) {
                    d[this.creatableColumns[c].prop] = this.creatableColumns[c].default
                }
            }
            this.$emit(`beforeOpenAddView`)
            if (row) {
                that.createDialog.data = _.cloneDeep(row)
            }
            that.createDialog.dialogFormVisible = true
            that.createDialog.title = that.enableAddButton.label
            that.$nextTick(() => {
                this.$refs[`create-dialog`].clearField()
                this.$set(that.createDialog, `data`, d)
            })
        },
        LoadingUpdateView({ row, index }) {
            let that = this
            this.showconfirm = true
            that.editDialog.title = that.enableUpdateButton.label
            return new Promise(resolve => {
                if (that._url.getOne) {
                    Promise.resolve(that._url.getOne(row)).then(data => {
                        that.editDialog.data = data
                        that.editDialog.dialogFormVisible = true
                        resolve(data)
                    })
                } else {
                    that.editDialog.data = _.cloneDeep(row)
                    that.editDialog.dialogFormVisible = true
                    resolve(that.editDialog.data)
                }
            })
        },
        LoadingDetailView({ row, index }) {
            let that = this
            this.showconfirm = false
            that.editDialog.title = that.enableDetailButton.label
            return new Promise(resolve => {
                if (that._url.getOne) {
                    Promise.resolve(that._url.getOne(row)).then(data => {
                        that.editDialog.data = data
                        that.editDialog.dialogFormVisible = true
                        resolve(data)
                    })
                } else {
                    that.editDialog.data = _.cloneDeep(row)
                    that.editDialog.dialogFormVisible = true
                    resolve(that.editDialog.data)
                }
            })
        },

        QueryData(reset) {
            // 查询当前页数据
            let that = this
            let promise
            let query = {}
            // if(this.searchValue && remote){
            //   query={ keyword:this.searchValue,page:this.page }
            // }else{
            //   query={ page:this.page}
            // }
            query = { page: this.page, reset: reset }
            if (this.searchValue) {
                query.keyword = this.searchValue
            }

            if (typeof this._url.get === `function`) {
                if (this.searchColumnData) {
                    query = _.assign(query, this.searchColumnData)
                }
                promise = Promise.resolve(this._url.get(query))
            } else {
                promise = this.myaxios.get(this._url.get, query)
            }
            return new Promise(resolve => {
                promise.then(
                    data => {
                        // 合并正在更改的行数据
                        if (that.rowChanges.length > 0) {
                            let keys = this.keyColumns
                            let deletedChanges = []
                            _.forEach(that.rowChanges, (rc, index) => {
                                let dataOne = _.find(data, d => {
                                    return _.every(keys, function(k) {
                                        return d[k.prop] === rc[k.prop]
                                    })
                                })
                                if (!dataOne) {
                                    deletedChanges.splice(0, 0, index)
                                }
                                dataOne && Object.assign(dataOne, rc)
                            })
                            if (deletedChanges.length > 0) {
                                _.forEach(deletedChanges, dindex => {
                                    that.rowChanges.splice(dindex, 1)
                                })
                            }
                        }
                        if (this.new_row_tag) {
                            let nr = _.filter(data, this.new_row_tag)
                            let keys = this.keyColumns
                            let r = _.differenceWith(this.rowChanges, nr, function(arrVal, othVal) {
                                return _.every(keys, function(k) {
                                    return arrVal[k.prop] === othVal[k.prop]
                                })
                            })
                            this.rowChanges = r.concat(nr)
                        }
                        resolve(data)
                    },
                    res => {
                        console.log(`load data faild.${res}`)
                        resolve([])
                    }
                )
            })
        },
        SaveData($data) {
            let that = this
            let data = { ...$data }
            let promise
            if (typeof this._url.post === `function`) {
                promise = Promise.resolve(this._url.post(data))
            } else {
                promise = this.myaxios.post(this._url.post, data)
            }
            promise
                .then(data => {
                    that.ReloadListData(true)
                    that.createDialog.dialogFormVisible = false
                })
                .catch(e => console.log(e))
        },
        UpdateData($data) {
            let that = this
            let keys = that.keyColumns
            if (keys.length == 0) {
                throw new Error(`Fcecade.vue columnList  must have keys.`)
            }
            let data = { ...$data }

            for (let k = 0; k < keys.length; k++) {
                data[keys[k].prop] = that.editDialog.data[keys[k].prop]
            }
            for (let key in data) {
                // 代码评审使用===
                if (data[key] === `` && key != `isExtraBtnClick`) {
                    data[key] = data[key] || that.minValue
                }
            }
            let promise
            if (typeof this._url.put === `function`) {
                promise = Promise.resolve(this._url.put(data))
            } else {
                promise = this.myaxios.put(this._url.put, data)
            }
            promise
                .then(data => {
                    that.ReloadListData(true)
                    that.editDialog.dialogFormVisible = false
                    if (this.afterUpdate) {
                        this.afterUpdate(data)
                    }
                })
                .catch(e => console.log(e))
        },
        DeleteData({ row, index }) {
            let that = this
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    let keys = that.keyColumns
                    if (keys.length == 0) {
                        throw new Error(`Fcecade.vue columnList  must have keys.`)
                    }
                    let data = {}
                    for (let k = 0; k < keys.length; k++) {
                        data[keys[k].prop] = row[keys[k].prop]
                    }
                    let promise
                    if (typeof this._url.delete === `function`) {
                        promise = Promise.resolve(this._url.delete(data))
                    } else {
                        promise = this.myaxios.delete(this._url.delete, data)
                    }
                    promise
                        .then(data => {
                            this.$message({
                                type: `success`,
                                message: `删除成功!`
                            })
                            that.ReloadListData(true)
                        })
                        .catch(e => console.log(e))
                })
                .catch(e => {})
        },
        ChangeCondition(data) {
            // console.log(data)
            this.searchColumnData = data
            this._search()
        },
        RowChange({ index, row, prop }) {
            let r = {}
            _.forEach(this.keyColumns, function(c) {
                if (row[c.prop] !== undefined) {
                    r[c.prop] = row[c.prop]
                }
            })
            let oldr = _.find(this.dataList_bak, r)
            let i = _.findIndex(this.rowChanges, r)
            if ((oldr && oldr[prop]) == row[prop] && this.rowChanges && this.rowChanges[i]) {
                this.$delete(this.rowChanges[i], prop)
                if (Object.getOwnPropertyNames(this.rowChanges[i]).length == 1 + this.keyColumns.length) {
                    this.rowChanges.splice(i, 1)
                }
            } else {
                r[prop] = row[prop]
                if (i > -1) {
                    this.rowChanges[i][prop] = row[prop]
                } else {
                    this.rowChanges.push(r)
                }
            }
        },
        OneUpdateData(data) {
            return new Promise((resolve, reject) => {
                let promise
                if (typeof this._url.put === `function`) {
                    promise = Promise.resolve(this._url.put(data))
                } else {
                    promise = this.myaxios.put(this._url.put, data)
                }
                promise
                    .then(data => {
                        resolve(true)
                    })
                    .catch(e => {
                        resolve(false)
                    })
            })
        },
        SaveChanges(i) {
            return new Promise((resolve, reject) => {
                //  保存用户更改，成功刷新数据，失败不刷新
                let that = this
                if (that.finished) {
                    that.finished = false
                    let promise
                    _.forEach(that.rowChanges, function(c) {
                        for (let key in c) {
                            // 代码评审使用===
                            if (c[key] === `` && key != `isExtraBtnClick`) {
                                c[key] = c[key] || that.minValue
                            }
                        }
                    })
                    if (typeof this._url.putMany === `function`) {
                        promise = Promise.resolve(this._url.putMany(that.rowChanges))
                    } else {
                        promise = this.myaxios.put(this._url.putMany, that.rowChanges)
                    }
                    promise
                        .then(data => {
                            that.finished = true
                            that.rowChanges = []
                            that.showDisplayOrder = false
                            that.ReloadListData()
                            resolve(that.finished)
                        })
                        .catch(e => {
                            that.finished = true
                            resolve(that.finished)
                            // that.ReloadListData()
                        })
                } else {
                    resolve()
                }
            })
        },

        AccurateQuery() {
            this.drawer = !this.drawer
            this.$emit(`accurateQuery`, this.drawer)
        },
        Reset() {
            this.$emit(`reset`)
            this.$refs[`exact_search`].$refs[`itemgroup`].resetFields()
            this.searchColumnData = {}
            this.searchValue = ``
            this._search()
        },
        loadMore() {
            let that = this
            this.loadBusy = true
            let $scroller = that.$refs[`scrollcontent`].ElInfiniteScroll.container
            if (!this.noMore) {
                // 本地加载,
                console.info(`crudfacecade load more`)
                let h = $scroller.scrollTop
                ++that.virtualPage
                that.$nextTick(function() {
                    $scroller.scrollTop = h
                })
                setTimeout(function() {
                    that.loadBusy = false
                }, 1000)
            } else if (this.infiniteLoad) {
                //  尝试远程加载
                that.noMore = false
                ++that.page
                console.log(`infiniteLoad ${that.page} page`)
                that.QueryData().then(data => {
                    if (data.length > 0) {
                        that.AppendListData(data)
                        this.loadBusy = false
                        that.loadMore()
                    } else {
                        that.noMore = true
                        --that.page
                    }
                })
            }
            // else if (!this.searchLocal) {
            //     that.noMore = false
            //     ++that.page
            //     that.QueryData().then((data) => {
            //         that.dataList_bak = data
            //     })
            // }
        },
        changeStatus() {
            let that = this
            this._datalist.forEach((d, index) => {
                d[that.status_column] = !d[that.status_column]
                that.RowChange({ index, row: d, prop: that.status_column })
            })
        },
        clearChanges() {
            this.finished = true
            this.rowChanges = []
            this.ReloadListData(true)
        },
        LoadUserColumns() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/SystemServer/GetColumnConfig`, {
                    tableName: this.tableName
                })
                req.then(data => {
                    let lcs = _.orderBy(that.listColumn, function(lc) {
                        return _.findIndex(data, { col_name: lc.prop })
                    })
                    that.configColumns = lcs.map(c => {
                        return { value: c.prop, label: c.label, col_width: c.col_width }
                    })
                    this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
                    this.user_config_columns2 =
                        (data &&
                            _.filter(data, { enabled: true }).map(d => {
                                return {
                                    col_name: d.col_name,
                                    col_width: d.col_width
                                }
                            })) ||
                        []
                    resolve(true)
                })
            })
        },
        SaveUserColumns() {
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: this.tableName
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                if (this.reload) {
                    this.reload()
                }
            }).catch(e => {})
        },
        changeColWidthBody(nw, ow, col, evt) {
            if (nw < 20) {
                nw = 20
            } else if (nw > 500) {
                nw = 500
            }
            let r = {
                col_name: col.property,
                col_width: parseInt(nw),
                table_name: this.tableName
            }
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnWidth`, r)
            req.then(data => {
                this.$message.success(`列宽调整成功`)
                // if (this.reload) {
                //     this.reload()
                // }
            }).catch(e => {})
        },
        changeColWidth(nw, ow, col, evt) {
            let that = this
            // 列宽值改变则post列宽
            if (this.tableName == `api_Preoperative/Apply_schedule_surgery` || this.tableName == `api_Preoperative/Apply_unschedule_surgery` || this.tableName == `api_Preoperative/Apply_schedule_surgerysimple`) {
                if (this.user_config_columns2.length == 0) {
                    let uc = this.configColumns.map((c, index) => {
                        return {
                            col_name: c.value,
                            display_order: index,
                            enabled: _.includes(this.user_config_columns, c.value),
                            table_name: this.tableName
                        }
                    })
                    let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
                    req.then(data => {
                        that.LoadUserColumns().then(d => {
                            that.changeColWidthBody(nw, ow, col, evt)
                        })
                    }).catch(e => {})
                } else {
                    that.changeColWidthBody(nw, ow, col, evt)
                }
            }
        },
        configColumnDrop() {
            if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        },
        exchangeRow(target) {
            this.$emit(`exchange-row`, target)
        }
    }
}
</script>

<style scoped lang="less">
.el-row {
    &:last-child {
        margin-bottom: 0;
    }
}
.exact_search {
    padding: 10px;
    background: #ffffff;
    /*height:40px;*/
    /*transition:display 1s*/
    /*transition: all 2s ease-out;*/
}

/deep/ .subitemRed {
    color: red !important;
}
/*.fade-enter-active, .fade-leave-active {
    transition: height 0.5s ease-out;
  }

  .fade-enter, .fade-leave-to {
    height: 0;
  }*/
.config-column {
    width: 200px;
    overflow: hidden;
    margin: 20px 0;
}
</style>
<style>
.config-column .el-checkbox-group .el-checkbox {
    display: table-row;
}
</style>



// WEBPACK FOOTER //
// src/common/CrudFacecade.vue